export const pattern1Data = [
  {
    id: 1,
    koreanChunks: ["가게가", "문연다 일찍"],
    englishChunks: ["The store", "opens early"],
    fullEnglish: "The store opens early.",
    explanation: "주어(S) + 동사(V) 구조의 1형식 문장입니다.",
  },
  {
    id: 2,
    koreanChunks: ["CEO는", "간다", "자주", "해외로", "비즈니스 회의를 위해"],
    englishChunks: [
      "The CEO",
      "goes",
      "frequently",
      "abroad",
      "for business meetings",
    ],
    fullEnglish: "The CEO goes abroad frequently for business meetings.",
    explanation:
      "주어(S) + 동사(V) + 부사(자주) + 부사구(해외로, ~를 위해) 구조의 1형식 문장입니다.",
  },
  {
    id: 3,
    koreanChunks: ["그 신입 사원은", "왔다", "일찍", "첫 출근 날"],
    englishChunks: ["The new employee", "came", "early", "on his first day"],
    fullEnglish: "The new employee came early on his first day.",
    explanation:
      "주어(S) + 동사(V) + 부사(일찍) + 부사구(~날) 구조의 1형식 문장입니다.",
  },
  {
    id: 4,
    koreanChunks: ["배달 트럭은", "운행된다", "매일 아침 7시에"],
    englishChunks: ["The delivery truck", "runs", "every morning at 7 a.m."],
    fullEnglish: "The delivery truck runs every morning at 7 a.m.",
    explanation: "주어(S) + 동사(V) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 5,
    koreanChunks: ["그녀는", "걸어간다", "사무실까지", "버스를 타는 대신"],
    englishChunks: ["She", "walks", "to the office", "instead of taking a bus"],
    fullEnglish: "She walks to the office instead of taking a bus.",
    explanation:
      "주어(S) + 동사(V) + 부사구(장소, 대신) 구조의 1형식 문장입니다.",
  },
  {
    id: 6,
    koreanChunks: ["많은 직장인들이", "간다", "해외로", "업무로 인해"],
    englishChunks: [
      "Many professionals",
      "travel",
      "internationally",
      "for work",
    ],
    fullEnglish: "Many professionals travel internationally for work.",
    explanation:
      "주어(S) + 동사(V) + 부사구(~로 인해) 구조의 1형식 문장입니다.",
  },
  {
    id: 7,
    koreanChunks: ["그 비행기는", "도착했다", "정시에", "악천후에도 불구하고"],
    englishChunks: [
      "The flight",
      "arrived",
      "on time",
      "despite the bad weather",
    ],
    fullEnglish: "The flight arrived on time despite the bad weather.",
    explanation:
      "주어(S) + 동사(V) + 부사구(시간, ~에도 불구하고) 구조의 1형식 문장입니다.",
  },
  {
    id: 8,
    koreanChunks: ["그 매니저는", "떠났다", "일찍", "회의에 참석하기 위해"],
    englishChunks: ["The manager", "left", "early", "to attend a conference"],
    fullEnglish: "The manager left early to attend a conference.",
    explanation:
      "주어(S) + 동사(V) + 부사(일찍) + 부사적 용법의 to부정사 구조의 1형식 문장입니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "그 회사는",
      "존재한다",
      "제공하기 위해",
      "혁신적인 솔루션을 ",
    ],
    englishChunks: [
      "The company",
      "exists",
      "to provide",
      "innovative solutions",
    ],
    fullEnglish: "The company exists to provide innovative solutions.",
    explanation:
      "주어(S) + 동사(V) + 부사적 용법의 to부정사 구조의 1형식 문장입니다.",
  },
  {
    id: 10,
    koreanChunks: ["불확실성이", "남아 있다", "주식 시장에는", "여전히"],
    englishChunks: ["Uncertainty", "remains", "in the stock market", "still"],
    fullEnglish: "Uncertainty remains in the stock market.",
    explanation:
      "주어(S) + 동사(V) + 부사구(장소) + 부사(여전히) 구조의 1형식 문장입니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "그 팀은",
      "머물렀다",
      "사무실에",
      "자정까지",
      "프로젝트를 끝내기 위해",
    ],
    englishChunks: [
      "The team",
      "stayed",
      "at the office",
      "until midnight",
      "to finish the project",
    ],
    fullEnglish:
      "The team stayed at the office until midnight to finish the project.",
    explanation:
      "주어(S) + 동사(V) + 부사구(장소, 시간) + 부사적 용법의 to부정사 구조의 1형식 문장입니다.",
  },
  {
    id: 12,
    koreanChunks: ["그 문서는", "사라졌다", "공유 폴더에서"],
    englishChunks: ["The document", "disappeared", "from the shared folder"],
    fullEnglish: "The document disappeared from the shared folder.",
    explanation: "주어(S) + 동사(V) + 부사구(장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 13,
    koreanChunks: ["이 매뉴얼은", "속한다", "참고 자료 섹션에"],
    englishChunks: ["This manual", "belongs", "in the reference section"],
    fullEnglish: "This manual belongs in the reference section.",
    explanation: "주어(S) + 동사(V) + 부사구(장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 14,
    koreanChunks: ["시스템 오류가", "발생했다", "소프트웨어 업데이트 중"],
    englishChunks: ["A system error", "happened", "during the software update"],
    fullEnglish: "A system error happened during the software update.",
    explanation: "주어(S) + 동사(V) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 15,
    koreanChunks: ["정전이", "발생했다", "심각한 날씨로 인해"],
    englishChunks: [
      "A power outage",
      "occurred",
      "due to severe weather conditions",
    ],
    fullEnglish: "A power outage occurred due to severe weather conditions.",
    explanation: "주어(S) + 동사(V) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 16,
    koreanChunks: ["연례 회의는", "열릴 것이다", "다음 주 금요일에"],
    englishChunks: ["The annual meeting", "will take place", "next Friday"],
    fullEnglish: "The annual meeting will take place next Friday.",
    explanation: "주어(S) + 동사(V) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 17,
    koreanChunks: ["그 계약은", "만료된다", "이번 달 말에"],
    englishChunks: ["The contract", "expires", "at the end of this month"],
    fullEnglish: "The contract expires at the end of this month.",
    explanation: "주어(S) + 동사(V) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 18,
    koreanChunks: ["새로운 보안 시스템은", "작동한다", "완벽하게"],
    englishChunks: ["The new security system", "works", "perfectly"],
    fullEnglish: "The new security system works perfectly.",
    explanation: "주어(S) + 동사(V) + 부사어(방법) 구조의 1형식 문장입니다.",
  },
  {
    id: 19,
    koreanChunks: ["새로운 소프트웨어는", "작동한다", "문제 없이"],
    englishChunks: ["The new software", "functions", "without any issues"],
    fullEnglish: "The new software functions without any issues.",
    explanation: "주어(S) + 동사(V) + 부사구(방법) 구조의 1형식 문장입니다.",
  },
  {
    id: 20,
    koreanChunks: ["그 보증은", "지속된다", "3년간", "구매일로부터"],
    englishChunks: [
      "The warranty",
      "lasts",
      "for three years",
      "from the purchase date",
    ],
    fullEnglish: "The warranty lasts for three years from the purchase date.",
    explanation: "주어(S) + 동사(V) + 부사구(기간) 구조의 1형식 문장입니다.",
  },
  {
    id: 21,
    koreanChunks: ["그 회사는", "성장했다", "크게", "지난 10년 동안"],
    englishChunks: [
      "The company",
      "grew",
      "significantly",
      "in the past decade",
    ],
    fullEnglish: "The company grew significantly in the past decade.",
    explanation:
      "주어(S) + 동사(V) + 부사구(방법+시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 22,
    koreanChunks: ["주가가", "올랐다", "급격하게", "그 발표 이후"],
    englishChunks: [
      "The stock price",
      "rose",
      "sharply",
      "after the announcement",
    ],
    fullEnglish: "The stock price rose sharply after the announcement.",
    explanation:
      "주어(S) + 동사(V) + 부사구(방법+시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 23,
    koreanChunks: ["시장 수요가", "감소했다", "경제적 불확실성으로 인해"],
    englishChunks: ["The market demand", "fell", "due to economic uncertainty"],
    fullEnglish: "The market demand fell due to economic uncertainty.",
    explanation: "주어(S) + 동사(V) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 24,
    koreanChunks: ["그 새 고층 건물은", "서 있다", "도심 한가운데에"],
    englishChunks: ["The new skyscraper", "stands", "in the city center"],
    fullEnglish: "The new skyscraper stands in the city center.",
    explanation: "주어(S) + 동사(V) + 부사구(장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 25,
    koreanChunks: ["기차는", "출발한다", "일정대로", "5번 플랫폼에서"],
    englishChunks: ["The train", "departs", "on schedule", "from platform 5"],
    fullEnglish: "The train departs on schedule from platform 5.",
    explanation:
      "주어(S) + 동사(V) + 부사구(방법+장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 26,
    koreanChunks: ["이사는", "돌아왔다", "중요한 해외 업무로부터"],
    englishChunks: [
      "The director",
      "returned",
      "from an important overseas assignment",
    ],
    fullEnglish: "The director returned from an important overseas assignment.",
    explanation:
      "주어(S) + 동사(V) + 부사구(원인/출처) 구조의 1형식 문장입니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "새로운 스타일이",
      "등장했다",
      "패션 산업에서",
      "얻으며 인기를 빠르게 ",
    ],
    englishChunks: [
      "A new style",
      "has emerged",
      "in the fashion industry",
      "gaining popularity quickly",
    ],
    fullEnglish:
      "A new style has emerged in the fashion industry, gaining popularity quickly.",
    explanation:
      "주어(S) + 동사(V) + 부사구(장소) + 분사구문 구조의 1형식 문장입니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "논의가",
      "진행되었다",
      "원활하게",
      "일부 초기 우려에도 불구하고",
    ],
    englishChunks: [
      "The discussions",
      "proceeded",
      "smoothly",
      "despite some initial concerns",
    ],
    fullEnglish:
      "The discussions proceeded smoothly despite some initial concerns.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(양보) 구조의 1형식 문장입니다.",
  },
  {
    id: 29,
    koreanChunks: ["그는", "거주한다", "잘 발달된 지역에", "도심 근처의"],
    englishChunks: [
      "He",
      "resides",
      "in a well-developed area",
      "close to downtown",
    ],
    fullEnglish: "He resides in a well-developed area close to downtown.",
    explanation: "주어(S) + 동사(V) + 부사구(장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 30,
    koreanChunks: ["여러 팀이", "뒤처졌다", "그들의 프로젝트 주요일정을"],
    englishChunks: [
      "Several teams",
      "fell behind",
      "on their project milestones",
    ],
    fullEnglish: "Several teams fell behind on their project milestones.",
    explanation: "주어(S) + 동사구(V) + 부사구(대상) 구조의 1형식 문장입니다.",
  },
  {
    id: 31,
    koreanChunks: ["그 회사는", "성장중이었다", "꾸준히", "글로벌 시장에서"],
    englishChunks: [
      "The company",
      "has been advancing",
      "steadily",
      "in the global market",
    ],
    fullEnglish:
      "The company has been advancing steadily in the global market.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(장소) 구조의 1형식 문장입니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "시장 수요는",
      "지속되고 있다",
      "경제적 어려움에도 불구하고",
    ],
    englishChunks: ["Market demand", "persists", "despite economic challenges"],
    fullEnglish: "Market demand persists despite economic challenges.",
    explanation: "주어(S) + 동사(V) + 부사구(양보) 구조의 1형식 문장입니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "주가는",
      "변동했다",
      "분기 내내",
      "전 세계적인 불확실성으로 인해",
    ],
    englishChunks: [
      "The stock prices",
      "fluctuated",
      "throughout the quarter",
      "due to global uncertainties",
    ],
    fullEnglish:
      "The stock prices fluctuated throughout the quarter due to global uncertainties.",
    explanation:
      "주어(S) + 동사(V) + 부사구(기간) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 34,
    koreanChunks: ["직원 사기가", "저하되었다", "최근 예산 삭감 이후"],
    englishChunks: [
      "Employee morale",
      "has deteriorated",
      "following recent budget cuts",
    ],
    fullEnglish:
      "Employee morale has deteriorated following recent budget cuts.",
    explanation: "주어(S) + 동사(V) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 35,
    koreanChunks: [
      "고객 만족도가",
      "향상되었다",
      "꾸준히",
      "새로운 서비스 출시 이후",
    ],
    englishChunks: [
      "Customer satisfaction",
      "has improved",
      "steadily",
      "since the launch of the new service",
    ],
    fullEnglish:
      "Customer satisfaction has improved steadily since the launch of the new service.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "정책은",
      "남아있다",
      "제자리에",
      "여러 번의 개정에도 불구하고",
    ],
    englishChunks: [
      "The policy",
      "remains",
      "in place",
      "despite multiple revisions",
    ],
    fullEnglish: "The policy remains in place despite multiple revisions.",
    explanation: "주어(S) + 동사구(V) + 부사구(양보) 구조의 1형식 문장입니다.",
  },
  {
    id: 37,
    koreanChunks: [
      "강력한 기업 문화가",
      "존재한다",
      "이 조직 내에",
      "촉진하며 혁신을",
    ],
    englishChunks: [
      "A strong corporate culture",
      "exists",
      "within the organization",
      "fostering innovation",
    ],
    fullEnglish:
      "A strong corporate culture exists within the organization, fostering innovation.",
    explanation:
      "주어(S) + 동사(V) + 부사구(장소) + 분사구문 구조의 1형식 문장입니다.",
  },
  {
    id: 38,
    koreanChunks: [
      "전통적인 비즈니스 모델이",
      "사라지는 중이다",
      "디지털 전환이 가속화되면서",
    ],
    englishChunks: [
      "Traditional business models",
      "are vanishing",
      "as digital transformation accelerates",
    ],
    fullEnglish:
      "Traditional business models are vanishing as digital transformation accelerates.",
    explanation:
      "주어(S) + 동사(V) + 부사절(시간/원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 39,
    koreanChunks: [
      "전자상거래 산업이",
      "번창하는 중이다",
      "증가로 인해 온라인쇼핑",
    ],
    englishChunks: [
      "The e-commerce industry",
      "is booming",
      "due to the rise of online shopping",
    ],
    fullEnglish:
      "The e-commerce industry is booming due to the rise of online shopping.",
    explanation: "주어(S) + 동사(V) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 40,
    koreanChunks: [
      "소비자 신뢰도가",
      "감소했다",
      "크게",
      "최근 경기 침체로 인해",
    ],
    englishChunks: [
      "Consumer confidence",
      "has declined",
      "significantly",
      "in response to the recent economic downturn",
    ],
    fullEnglish:
      "Consumer confidence has declined significantly in response to the recent economic downturn.",
    explanation:
      "주어(S) + 동사(V) + 부사(정도) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 41,
    koreanChunks: [
      "주식 시장은",
      "회복되었다",
      "빠르게",
      "정부가 발표한 후 새로운 경제 정책을",
    ],
    englishChunks: [
      "The stock market",
      "recovered",
      "quickly",
      "after the government announced new economic policies",
    ],
    fullEnglish:
      "The stock market recovered quickly after the government announced new economic policies.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사절(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 42,
    koreanChunks: [
      "매출이",
      "감소했다",
      "급격히",
      "지난 분기에",
      "공급망 차질로 인해",
    ],
    englishChunks: [
      "Sales",
      "dropped",
      "sharply",
      "last quarter",
      "due to supply chain disruptions",
    ],
    fullEnglish:
      "Sales dropped sharply last quarter due to supply chain disruptions.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(시간) + 부사구(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "주택 가격이",
      "상승했다",
      "꾸준히",
      "지난 1년 동안",
      "강한 수요로 인해",
    ],
    englishChunks: [
      "Housing prices",
      "have increased",
      "steadily",
      "over the past year",
      "driven by strong demand",
    ],
    fullEnglish:
      "Housing prices have increased steadily over the past year, driven by strong demand.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(기간) + 분사구문(원인) 구조의 1형식 문장입니다.",
  },
  {
    id: 44,
    koreanChunks: [
      "구인 공고 수가",
      "감소했다",
      "조금",
      "3월에",
      "비교해서 지난달과",
    ],
    englishChunks: [
      "The number of job openings",
      "decreased",
      "slightly",
      "in March",
      "compared to the previous month",
    ],
    fullEnglish:
      "The number of job openings decreased slightly in March compared to the previous month.",
    explanation:
      "주어(S) + 동사(V) + 부사(정도) + 부사구(시간) + 분사구문(비교) 구조의 1형식 문장입니다.",
  },
  {
    id: 45,
    koreanChunks: [
      "보안 시스템은",
      "작동한다",
      "효율적으로",
      "보장하며 원활한 사용자 경험을",
    ],
    englishChunks: [
      "The security system",
      "operates",
      "efficiently",
      "ensuring a smooth user experience",
    ],
    fullEnglish:
      "The security system operates efficiently, ensuring a smooth user experience.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 분사구문 구조의 1형식 문장입니다.",
  },
  {
    id: 46,
    koreanChunks: [
      "여러 차례 시도에도 불구하고",
      "백업 서버가",
      "작동하지 않았다",
      "예상치 못하게",
    ],
    englishChunks: [
      "Despite multiple attempts",
      "the backup server",
      "failed",
      "unexpectedly",
    ],
    fullEnglish:
      "Despite multiple attempts, the backup server failed unexpectedly.",
    explanation:
      "부사구(양보) + 주어(S) + 동사(V) + 부사(방법) 구조의 1형식 문장입니다.",
  },
  {
    id: 47,
    koreanChunks: [
      "대변인은",
      "반응했다",
      "신속하게",
      "정책 변경과 관련된 언론의 질문에",
    ],
    englishChunks: [
      "The spokesperson",
      "responded",
      "promptly",
      "to media inquiries about the policy changes",
    ],
    fullEnglish:
      "The spokesperson responded promptly to media inquiries about the policy changes.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(대상) 구조의 1형식 문장입니다.",
  },
  {
    id: 48,
    koreanChunks: [
      "고객들은",
      "반응했다",
      "긍정적으로",
      "신제품의 혁신적인 디자인에",
    ],
    englishChunks: [
      "Customers",
      "reacted",
      "positively",
      "to the new product's innovative design",
    ],
    fullEnglish:
      "Customers reacted positively to the new product's innovative design.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(대상) 구조의 1형식 문장입니다.",
  },
  {
    id: 49,
    koreanChunks: [
      "물가 상승에 따라",
      "소비자 지출 패턴이",
      "꾸준히",
      "변화한다",
    ],
    englishChunks: [
      "As inflation rises",
      "consumer spending patterns",
      "steadily",
      "change",
    ],
    fullEnglish:
      "As inflation rises, consumer spending patterns change steadily.",
    explanation:
      "부사절(시간/조건) + 주어(S) + 부사(방법) + 동사(V) 구조의 1형식 문장입니다.",
  },
  {
    id: 50,
    koreanChunks: [
      "폭우 이후",
      "강의 수위가",
      "내려갔다",
      "위험한 낮은수준으로",
    ],
    englishChunks: [
      "After heavy rainfall",
      "water levels in the river",
      "sank",
      "to a dangerous low",
    ],
    fullEnglish:
      "After heavy rainfall, water levels in the river sank to a dangerous low.",
    explanation:
      "부사구(시간) + 주어(S) + 동사(V) + 부사구(정도) 구조의 1형식 문장입니다.",
  },
  {
    id: 51,
    koreanChunks: [
      "잘못된 정보가",
      "퍼졌다",
      "빠르게",
      "소셜 미디어에 걸쳐서",
      "보도 자료 발표 이후",
    ],
    englishChunks: [
      "Misinformation",
      "spread",
      "rapidly",
      "across social media",
      "following the press release",
    ],
    fullEnglish:
      "Misinformation spread rapidly across social media following the press release.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(장소) + 부사구(시간) 구조의 1형식 문장입니다.",
  },
  {
    id: 52,
    koreanChunks: [
      "교통이",
      "흘렀다",
      "원활하게",
      "아침 러시아워에도 불구하고",
    ],
    englishChunks: [
      "Traffic",
      "flowed",
      "smoothly",
      "despite the morning rush hour",
    ],
    fullEnglish: "Traffic flowed smoothly despite the morning rush hour.",
    explanation:
      "주어(S) + 동사(V) + 부사(방법) + 부사구(양보) 구조의 1형식 문장입니다.",
  },
];
